const baseUrl = process.env.REACT_APP_BACKEND_URL;
export default {
  home: baseUrl+'/api/home?api=3',
  fiche: baseUrl+'/api/mission/get/:missionId/fiche/:ficheId?api=3',
  profile: baseUrl+'/api/profil/get?api=3',
  missions: baseUrl+'/api/missions/get/:missionId?api=3',
  legal: baseUrl+'/api/legal/get?api=3',
  login: baseUrl+'/api/login',
  logout: baseUrl+'/api/logout',
  fb: 'https://www.facebook.com/search/top/?q=lobster%20-%20vidéo%20recrutement',
  ld: 'https://www.linkedin.com/company/lobster---vid-o-recrutement/'
};



// WEBPACK FOOTER //
// ./src/config/api.jsx